import { useRef, useCallback } from 'react';

const useMultipleRefs = (...refs) => {
    const passedRefs = useRef(refs);
    passedRefs.current = refs;
    const refMultiplexer = useCallback((ref) => {
        passedRefs.current.forEach((r) => {
            if (typeof r === 'function') {
                r(ref);
                return;
            }
            r && (r.current = ref);
        });
    }, [passedRefs]);
    return refMultiplexer;
};

export { useMultipleRefs };
//# sourceMappingURL=index.js.map
